import { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import css from './index.module.css';
import Content from '@components/adminNavigation';
import axios from "axios";
import * as Types from '../../../types';
import { toast } from 'sonner';
import SEO from '@components/seo';

export default function Category() {
  const { id } = useParams();
  const [categories, setCatories] = useState<Types.Category[]>();
  const [category, setCategory] = useState<Types.Category>();
  
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/categories`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    }).then(response => {
        setCatories(response.data);
        setCategory(response.data.find((item: Types.Category) => item.id === parseInt(id!)));
    }).catch(error => {
      console.log(error);
    });
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
  
    setCategory((prev) => {
      if (!prev) return prev;
  
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/category/${id}`, category, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
    })
    .then(_ => {
      toast.success('Информация обновлена')
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка');
    });
  };

  return (
    <Content>
      <SEO 
        title={'Управление категорией'}
        description={'Админ-панель'}
        ogUrl={`https://рыбныимир.рф/`}
      />

      <h1 className={css.head}>{category?.name}</h1>
      <form onSubmit={handleSubmit}>
        <div className={css.inputGrid}>
          <label>Название категории</label>
          <input name='name' type='text' placeholder='Название категории' value={category?.name} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Мини описание</label>
          <input name='miniDesc' type='text' placeholder='Мини описание' value={category?.miniDesc} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Родительская категория</label>
          <select name='parent' onChange={handleChange}>
              <option value={0}>Нет</option>

              {categories?.map(item => (
                  <option value={item.id} selected={category?.id === item.id}>{item.name}</option>
              ))}
          </select>
        </div>
        
        <button className={css.saveBtn} type='submit'>Сохранить изменения</button>
      </form>
    </Content>
  );
}
